export const transparencia_item = [
    {
        "transparencia_item_nombre" : "Articulo 69 Ley de Transparencia (48 Rubros)",
        "transparencia_item_url" : "Rubros"
    },
    {
        "transparencia_item_nombre" : "Articulo 70 Ley de Transparencia ",    
        "transparencia_item_url" : "https://transparenciadocs.hidalgo.gob.mx/dependencias/Semot/dir3/Historico/2025/a70_f01_gSEMOT.xlsx",         
    
    },
    
    {
        "transparencia_item_nombre" : "Rubros Anteriores ",    
        "transparencia_item_url" : "/Transparencia/Rubros/RubrosHistoricos",         
    
    }
]